module.exports = __webpack_public_path__ + "static/img/mypage-navigation-menu04.38ba9984.svg";